<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		title: string;
		children?: Snippet;
	}

	const { title, children }: Props = $props();
</script>

<div>
	<div class="text-lg mb-2">{title}</div>
	{@render children?.()}
</div>
